import { render, staticRenderFns } from "./RecipientSelect.vue?vue&type=template&id=78b2e6b6"
import script from "./RecipientSelect.vue?vue&type=script&lang=ts"
export * from "./RecipientSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports